import { render } from "./appTeachResearch.vue?vue&type=template&id=4c1e5e84&scoped=true"
import script from "./appTeachResearch.vue?vue&type=script&lang=js"
export * from "./appTeachResearch.vue?vue&type=script&lang=js"

import "./appTeachResearch.vue?vue&type=style&index=0&id=4c1e5e84&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1e5e84"]])

export default __exports__